export default {
  init() {
    // JavaScript to be fired on all pages
    const $dateRange = $('#daterange');
    const moment = require('moment');

    const _dateRangeFilter = () => {
      if (!$dateRange.length) { return false; }
      let dateRangeOptions = {
        'locale': {
          'format': 'DD/MM/YYYY',
          'separator': ' - ',
          'applyLabel': 'Aanvragen',
          'cancelLabel': 'Annuleren',
          'fromLabel': 'Van',
          'toLabel': 'To',
          'customRangeLabel': 'Datumbereik',
          'weekLabel': 'W',
          'daysOfWeek': [
            'Zo',
            'Ma',
            'Di',
            'Wo',
            'Do',
            'Vr',
            'Za',
          ],
          'monthNames': [
            'Januari',
            'Februari',
            'Maart',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Augustus',
            'September',
            'Oktober',
            'November',
            'December',
          ],
        },
        'minYear': 2018,
        'maxYear': 2030,
        'opens': 'left',
        'showDropdowns': true,
        'showWeekNumbers': true,
        ranges: {
          'Vandaag': [moment(), moment()],
          'Gisteren': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Laatste 7 dagen': [moment().subtract(6, 'days'), moment()],
          'Laatste 30 dagen': [moment().subtract(29, 'days'), moment()],
          'Deze maand': [moment().startOf('month'), moment().endOf('month')],
          'Vorige maand': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
        'alwaysShowCalendars': true,
        'applyButtonClasses': 'btn btn-dark',
      };

      if ($('#start_date').length > 0 && $('#end_date').length > 0) {
        let start_date = $('#start_date').val();
        let end_date = $('#end_date').val();
        if (start_date !== '' || end_date !== '') {
          dateRangeOptions.startDate = new Date(start_date);
          dateRangeOptions.endDate = new Date(end_date);
        }
      }

      $dateRange.daterangepicker(dateRangeOptions);
    };

    _dateRangeFilter();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/application.js